import React from "react";
import { NavLink } from "react-router-dom";

import { appRoutes } from "routes";

import useStyles from "./useStyles";

const CancelButton = () => {
  const classes = useStyles();

  return (
    <NavLink exact className={classes.link} to={appRoutes.myAccountPath()}>
      Cancel
    </NavLink>
  );
};

export default CancelButton;
